import { css } from 'styled-components';
import { outlineBase } from './outline.js';

const getSwitchBase = ()=>{
    return css`
    ${outlineBase}
    display: flex;
    position: relative;
    transition:
      background-color 0.2s ease-out,
      outline-color 0.2s ease-out;

    &:after {
      border-color: transparent;
      border-style: solid;
      border-width: 1px;
      content: '';
      display: block;
      position: absolute;
      top: 0;
      transition:
        border-color 0.2s ease-out,
        right 0.2s ease-out;
    }
  `;
};
const getSwitchChecked = (options)=>{
    const { look } = options;
    return css`
    background-color: ${({ theme })=>theme.switch[look].backgroundColorChecked};

    &:after {
      background-color: ${({ theme })=>theme.switch[look].switchBackgroundColorChecked};
      border-color: ${({ theme })=>theme.switch[look].switchBorderColorChecked};
      right: 0;
    }
  `;
};
const getSwitchUnchecked = (options)=>{
    const { look } = options;
    return css`
    background-color: ${({ theme })=>theme.switch[look].backgroundColor};

    &:after {
      background-color: ${({ theme })=>theme.switch[look].switchBackgroundColor};
      border-color: ${({ theme })=>theme.switch[look].switchBorderColor};
    }
  `;
};
const getSwitchDisabled = (options)=>{
    const { look } = options;
    return css`
    background-color: ${({ theme })=>theme.switch[look].backgroundColorDisabled};
    cursor: not-allowed;

    &:after {
      background-color: ${({ theme })=>theme.switch[look].switchBackgroundColorDisabled};
      border-color: ${({ theme })=>theme.switch[look].switchBorderColorDisabled};
    }
  `;
};
const getSwitchOutline = (options)=>{
    const { look } = options;
    return css`
    outline-color: ${({ theme })=>theme.switch[look].outlineColorFocus};
  `;
};
const switchReducedMotion = css`
  transition: none;

  &:after {
    transition: none;
  }
`;
const switchSmall = css`
  border-radius: 8px;
  height: 16px;
  width: 28px;

  &:after {
    border-radius: 8px;
    height: 16px;
    width: 16px;
  }
`;
const switchSmallOff = css`
  right: calc(100% - 16px);
`;
const switchSmallLabelLeft = css`
  .bf-switch__text {
    margin-inline-end: 12px;
  }

  .bf-text__help {
    margin-inline-end: 40px;
  }
`;
const switchSmallLabelRight = css`
  .bf-switch__text {
    margin-inline-start: 12px;
  }

  .bf-text__help {
    margin-inline-start: 40px;
  }
`;
const switchMedium = css`
  border-radius: 12px;
  height: 24px;
  width: 40px;

  &:after {
    border-radius: 12px;
    height: 24px;
    width: 24px;
  }
`;
const switchMediumLabelLeft = css`
  .bf-switch__text {
    margin-inline-end: 16px;
  }

  .bf-text__help {
    margin-inline-end: 56px;
  }
`;
const switchMediumLabelRight = css`
  .bf-switch__text {
    margin-inline-start: 16px;
  }

  .bf-text__help {
    margin-inline-start: 56px;
  }
`;
const switchMediumOff = css`
  right: calc(100% - 24px);
`;

export { getSwitchBase, getSwitchChecked, getSwitchDisabled, getSwitchOutline, getSwitchUnchecked, switchMedium, switchMediumLabelLeft, switchMediumLabelRight, switchMediumOff, switchReducedMotion, switchSmall, switchSmallLabelLeft, switchSmallLabelRight, switchSmallOff };
//# sourceMappingURL=switch.js.map
